import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";

@Component({
  selector: "app-single-select-dropdown",
  templateUrl: "./single-select-dropdown.component.html",
  styleUrls: ["./single-select-dropdown.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SingleSelectDropdownComponent implements OnInit {
  @Input() label: string;
  @Input() items: [];
  @Input() width: string;
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() selectedItem;
  @Input() placeholder = "Select Rebase";
  @Input() disabled = false;
  @Input() treatValueAsLable;

  ngOnInit() {
    return;
  }

  //ngOnChanges(changes: SimpleChanges) {
  // if (changes.items && changes.items.currentValue) {
  //   this.items = changes.items.currentValue;
  // }
  //}

  onItemChange(selectedVal) {
    this.callback.emit(selectedVal);
  }
}
